import React from 'react';
import RunningGuy from './RunningGuy';

class IOSPreviousDecline extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className={'container'}>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}>
                    <div style={{ maxWidth: '90%', margin: '0 5%' }}>
                        <br /><RunningGuy />
                    </div>
                    <div style={{padding: '0 25px 0 25px' }} className={'grey-font'}>
                        <div style={{textAlign: 'center', paddingTop:20, paddingBottom:20 }}>
                            <span className={'activity-tracker-permissions-header'}>Track your steps and earn digital badges!</span>
                        </div>
                        <div style={{textAlign: 'left', paddingTop:20, paddingBottom:20 }}>
                            <span className={'activity-tracker-permissions-description'}>We're having trouble retrieving your information, check back later.</span>
                        </div>
                    </div>
                </div>
                <br />
                <br />
                <br />
                <br />
            </div>
        )
    }
}

export default IOSPreviousDecline;


// WEBPACK FOOTER //
// ./src/Components/ActivityTracker/StepTrackerError.js